/**
 * Cart Gift Note Sync Component
 * 
 * Syncs gift note from cart attributes to line item properties
 * so it's accessible in packing slips.
 */
(function () {
  'use strict';

  function initGiftNoteSync() {
    const giftNoteTextarea = document.getElementById('CartGiftNote');

    if (!giftNoteTextarea) return;

    // Function to sync gift note to all line items as properties
    // This makes it accessible in packing slips
    async function syncGiftNoteToLineItems() {
      const giftNote = giftNoteTextarea.value.trim();

      try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) {
          console.error('Failed to fetch cart');
          return Promise.resolve();
        }
        const cart = await cartResponse.json();

        if (!cart.items || cart.items.length === 0) {
          return Promise.resolve();
        }

        // Update each line item to include gift_note as a property
        const updatePromises = [];
        for (const item of cart.items) {
          const properties = {};

          // Copy existing properties (excluding gift_note to avoid duplicates)
          if (item.properties) {
            Object.keys(item.properties).forEach((key) => {
              if (key !== 'gift_note') {
                properties[key] = item.properties[key];
              }
            });
          }

          // Add gift note if it exists
          if (giftNote) {
            properties.gift_note = giftNote;
          }

          // Update line item with new properties
          const updatePromise = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              properties: properties,
            }),
          }).catch((error) => {
            console.error('Error updating line item:', error);
          });
          updatePromises.push(updatePromise);
        }

        // Wait for all updates to complete
        await Promise.all(updatePromises);
        return Promise.resolve();
      } catch (error) {
        console.error('Error syncing gift note to line items:', error);
        return Promise.resolve();
      }
    }

    // Sync when gift note changes (debounced to avoid too many API calls)
    let syncTimeout;
    giftNoteTextarea.addEventListener('input', function () {
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(syncGiftNoteToLineItems, 1500);
    });

    // Sync when user leaves the field
    giftNoteTextarea.addEventListener('blur', syncGiftNoteToLineItems);

    // Sync before checkout button is clicked
    const checkoutButton = document.querySelector('button[name="checkout"]');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', function (e) {
        // Sync immediately when checkout is clicked
        const giftNote = giftNoteTextarea.value.trim();
        if (giftNote) {
          // Don't prevent default, but sync in parallel
          syncGiftNoteToLineItems();
        }
      });
    }

    // Also sync when form is submitted (as backup)
    const cartForm = document.querySelector('form.cart');
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        const submitter = e.submitter;
        if (submitter && submitter.name === 'checkout') {
          const giftNote = giftNoteTextarea.value.trim();
          if (giftNote) {
            // Sync immediately (non-blocking)
            syncGiftNoteToLineItems();
          }
        }
      });
    }

    // Initial sync on page load if gift note exists
    if (giftNoteTextarea.value.trim()) {
      setTimeout(syncGiftNoteToLineItems, 2000);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftNoteSync);
  } else {
    initGiftNoteSync();
  }
})();
